import appStore from 'store';
import api from './api';
import {PAGINATION} from './constants';

const store = {
    namespaced: true,
    state: {
        currencyList: [],
        contractCodeList: [],
        detailDialogVisible: false,
        pagination: PAGINATION,
        totalCount: 0,
        spriteUrl: '',
        logoInfo: [],
        currCoinType:"",
        coinConfig:null,
        coinCon:{withdrawFeeType:0}
    },
    getters: {
        currencyList: state => {
            return state.currencyList;
        },
        contractCodeList: state => {
            return state.contractCodeList;
        },
    },
    mutations: {
        setContractCodeList(state, payload) {
            state.contractCodeList = payload;
        },
        setCurrencyList(state, payload) {
            state.currencyList = payload.list.slice();
            state.totalCount = payload.totalCount;
        },
        toggleDetailDialogVisible(state, payload) {
            state.detailDialogVisible = payload;
        },
        toggleCurrCoinType(state, payload) {
            state.currCoinType = payload;
        },
        setPagination(state, payload) {
            state.pagination = payload;
        },
        setSpriteUrl(state, payload) {
            state.spriteUrl = payload;
        },
        setLogoInfo(state, payload) {
            state.logoInfo = payload;
        },
        setCoinConfig(state, payload){
            state.coinCon = payload;
        }
    },
    actions: {
        getCoinConfig({commit}, data) {
            api.getCoinConfig(data).then(({data}) => {
                if (data!=null){
                    commit('setCoinConfig', data);
                }
            });
        },
        getContractCodeList({commit}) {
            api.getContractCodeList().then(({data}) => {
                commit('setContractCodeList', data);
            });
        },
        list({commit}, {code, page, size, areaType}) {
            api.getCurrencyList({code, page, size, areaType}).then(({data}) => {
                commit('setPagination', {page, size});
                commit('setCurrencyList', data);
            });
        },
        // eslint-disable-next-line
        updateDepositStatus({commit}, data) {
            return new Promise(resolve => {
                api.updateDepositStatus(data).then(res => {
                    resolve(res);
                });
            });
        },
        // eslint-disable-next-line
        updateWithdrawStatus({commit}, data) {
            return new Promise(resolve => {
                api.updateWithdrawStatus(data).then(res => {
                    resolve(res);
                });
            });
        },
        // eslint-disable-next-line
        create({commit}, currency) {
            return new Promise(resolve => {
                api.createCurrency(currency).then(res => {
                    resolve(res);
                });
            });
        },
        // eslint-disable-next-line
        update({commit}, currency) {
            return new Promise(resolve => {
                api.updateCurrency(currency).then(res => {
                    resolve(res);
                });
            });
        },
        // eslint-disable-next-line
        remove({commit}, code) {
            return new Promise(resolve => {
                api.removeCurrency(code).then(res => {
                    resolve(res);
                });
            });
        },
        // eslint-disable-next-line
        updateTradeStatus({commit}, data) {
            return api.updateTradeStatus(data);
        },
        updateAggregateTradeStatus({commit}, data) {
            return api.updateAggregateTradeStatus(data);
        },
        updateDisplayStatus(context, data) {
            return api.updateDisplayStatus(data);
        },
        updateAreaType(context, data) {
            return api.updateAreaType(data);
        },
        updateShelve({commit}, data) {
            return api.updateShelve(data);
        },
        updateSort(context, data) {
            return api.updateSort(data);
        },
        detail({commit}, coinType) {
            commit('toggleCurrCoinType', coinType);
        },
        getLogoInfo({commit}) {
            api.getCoinLogoInfo().then(({data}) => {
                commit('setSpriteUrl', data.url);
                commit('setLogoInfo', data.coinLogoInfoList);
            });
        },
        updateLogoInfo(context, data) {
            return api.updateCoinLogoInfo(data);
        },

        updateCoinDepositStatus({commit}, data) {
            return api.updateCoinDepositStatus(data);
        }
    }
};

appStore.registerModule('currencySetting', store);
